import { getWorkstationsByLocalId } from '../../../../../crud/management_api/workstations';
import React, { useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { Puestos } from '../../types';
import { toast } from 'react-toastify';
import { createPuesto, updatePuesto, deletePuestoById } from '../../../../../crud/management_api/puestos';
import SearchDropdown from '../../../../../components/common/SearchDropdown/SearchDropdown';
import './RenderCreatePuestoModal.scss';

export interface WorkstationOption {
    id: number;
    name: string;
}

export const getWorkstationsOptions = async () => {
    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;
    const response = await getWorkstationsByLocalId(localId);
    if (response) {
        const data = response.data;
        if (data) {
            const workstations: WorkstationOption[] = data.map((workstation: any) => {
                return {
                    id: workstation.workstation_id,
                    name: workstation.workstation_name,
                };
            });
            return [{ id: 0, name: 'Ninguna' }, ...workstations];
        }
    }
    return [];
};

/* _________________Create Function:_________________*/

export const RenderCreatePuestosModal: React.FC<any> = ({
    showCreateModal,
    setShowCreateModal,
    setCurrentData,
    currentData,
}) => {
    const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
    const [isActive, setIsActive] = useState(true);
    const [workstationName, setWorkstationName] = useState<string>('');
    const [workstationId, setWorkstationId] = useState('0');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getWorkstationsOptions().then((response) => {
            if (response) {
                setWorkstations(response);
                setWorkstationId(String(response[0]?.id ?? '0'));
                setWorkstationName(response[0]?.name ?? '');
            }
        });
    }, []);

    const handleActiveChange = (e: any) => {
        setIsActive(e.target.checked);
    };

    const handleWorkstationChange = (selected: WorkstationOption) => {
        setWorkstationName(selected.name);
        setWorkstationId(String(selected.id));
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (!form) {
            console.error('Form not found.');
            return;
        }
        setIsLoading(true);
        const userContext = localStorage.getItem('user');
        const localId = userContext != null ? JSON.parse(userContext).local_id : 0;

        const finalWorkstationId = workstationId === '0' ? '' : workstationId;

        const create_Puesto: Puestos = {
            puesto_id: '',
            puesto_name: form.puesto_name.value,
            puesto_description: form.puesto_description.value,
            workstation_id: finalWorkstationId,
            workstation_name: workstationName,
            local_id: localId,
            state: true,
            created_at: '',
            users:[],   
        };

      createPuesto(create_Puesto)
        .then((response) => {
          create_Puesto.puesto_id = (response as any).data.puesto_id;
          toast.success('Puesto creado con éxito!');
          setShowCreateModal(false);

          let updatedData = currentData.filter((p: any) => p.puesto_id !== create_Puesto.puesto_id);
          updatedData = [create_Puesto, ...updatedData];

          setCurrentData(updatedData);
        })
        .catch((error) => {
                console.error('Error al crear un puesto:', error);
                toast.error('Error al crear un puesto');
            })
            .finally(() => {
              setIsLoading(false);
            });
    };

    const WorkstationsDropdown = (
        <div className="mp-form-group">
            <label className="mp-form-label">Estación de trabajo por defecto</label>
            <SearchDropdown
                items={workstations}
                selected={workstations.find((w) => String(w.id) === String(workstationId)) || null}
                setSelected={handleWorkstationChange}
                displayProperty="name"
                idProperty="id"
                placeholder="Seleccione una estación"
            />
        </div>
    );

    return (
        <Modal className='modal-create-puesto' show={showCreateModal} onHide={() => setShowCreateModal(false)}>
            <Form onSubmit={handleFormSubmit}>
                <Modal.Header>
                    <div className="form-modal-title-container">
                        <Modal.Title className="form-modal-title">Crear puesto de trabajo</Modal.Title>
                    </div>
                    <button type="button" className="modal-close-button" onClick={() => setShowCreateModal(false)}>
                        <X size={22} />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="px-2 py-1 flex flex-col gap-0">
                        <div className="mp-form-group">
                            <label className="mp-form-label">Nombre</label>
                            <input className="mp-form-input" type="text" name="puesto_name" placeholder="Nombre del puesto" required />
                        </div>
                        <div className="mp-form-group">
                            <label className="mp-form-label">Descripción</label>
                            <input className="mp-form-input" type="text" name="puesto_description" placeholder="Descripción" required />
                        </div>
                        {WorkstationsDropdown}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="mp-modal-footer">
                        <button type="button" className="mp-modal-btn-cancel" onClick={() => setShowCreateModal(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="mp-modal-btn-submit">
                            {isLoading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Creando...
                                </>
                            ) : (
                                'Crear'
                            )}
                        </button>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export const RenderUpdatePuestosModal: React.FC<any> = ({
  showEditModal,
  setShowEditModal,
  setCurrentData,
  currentData,
  currentPuesto
}) => {
  const [workstations, setWorkstations] = useState<WorkstationOption[]>([]);
  const [isActive, setIsActive] = useState(true);
  const [WorkstationId, setWorkstationId] = useState('');

  useEffect(() => {
    if (currentPuesto) {
      setIsActive(currentPuesto.state);
      setWorkstationId(String(currentPuesto.workstation_id));
    }
  }, [currentPuesto]);

  useEffect(() => {
    getWorkstationsOptions().then((response) => {
      if (response) {
        setWorkstations(response);
      }
    });
  }, []);

  const handleActiveChange = (e: any) => {
    setIsActive(e.target.checked);
  };

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (!form) {
      console.error('Form not found.');
      return;
    }

    const userContext = localStorage.getItem('user');
    const localId = userContext != null ? JSON.parse(userContext).local_id : 0;

    const selectedWorkstation = workstations.find(ws => String(ws.id) === WorkstationId);
    const workstationName = selectedWorkstation ? selectedWorkstation.name : '';
    const wsId = Number(WorkstationId);

    const edit_Puesto: Puestos = {
      ...currentPuesto,
      puesto_name: form.puesto_name.value,
      puesto_description: form.puesto_description.value,
      workstation_id: wsId,
      workstation_name: workstationName,
      
    };

  updatePuesto(Number(edit_Puesto.puesto_id), edit_Puesto)
    .then(response => {
      setShowEditModal(false);
      const updatedData = currentData.map((p: Puestos) =>
      p.puesto_id === edit_Puesto.puesto_id
        ? {
            ...p,
            puesto_name: edit_Puesto.puesto_name,
            puesto_description: edit_Puesto.puesto_description,
            workstation_id: edit_Puesto.workstation_id,
            workstation_name: edit_Puesto.workstation_name,
          }
        : p
    );

      setCurrentData(updatedData);
      toast.success('Puesto Actualizado con Éxito!');
    })
    .catch(error => {
      console.error('Error al editar un puesto:', error);
      toast.error('Error al editar un puesto');
    });
  };

  const WorkstationsDropdown = (
    <div className="mp-form-group">
      <label className="mp-form-label">Estación de trabajo</label>
      <SearchDropdown
        items={workstations}
        selected={workstations.find((w) => String(w.id) === String(WorkstationId)) || null}
        setSelected={(selected: WorkstationOption) => setWorkstationId(String(selected.id))}
        displayProperty="name"
        idProperty="id"
        placeholder="Seleccione una estación"
      />
    </div>
  );

  return (
    <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
      <Form onSubmit={handleFormSubmit}>
        <Modal.Header>
          <div className='form-modal-title-container'>
            <Modal.Title className='form-modal-title'>Actualizar puesto</Modal.Title>
          </div>
          <button type="button" className="modal-close-button" onClick={() => setShowEditModal(false)}>
            <X size={22} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="px-2 py-1 flex flex-col gap-0">
            <div className="mp-form-group">
              <label className="mp-form-label">Nombre</label>
              <input className="mp-form-input" type="text" name="puesto_name" placeholder="Nombre del puesto" defaultValue={currentPuesto?.puesto_name} required />
            </div>
            <div className="mp-form-group">
              <label className="mp-form-label">Descripción</label>
              <input className="mp-form-input" type="text" name="puesto_description" placeholder="Descripción" defaultValue={currentPuesto?.puesto_description} required />
            </div>
            {WorkstationsDropdown}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="mp-modal-footer">
            <button type="button" className="mp-modal-btn-cancel" onClick={() => setShowEditModal(false)}>Cancelar</button>
            <button type="submit" className="mp-modal-btn-submit">Actualizar</button>
          </div>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const RenderDeletePuestoModal: React.FC<any> =  ({
      showDeleteModal,
      setShowDeleteModal,
      currentPuesto,
      currentData,
      setCurrentData
    }
    ) => {
      const handleDeletePuesto = async () => {
        if (currentPuesto) {
          try {
           const isSuccess = await deletePuestoById(Number(currentPuesto.puesto_id));
            if (isSuccess) {
              toast.success('Puesto eliminado con éxito!');
                const updatedData = currentData.filter((puesto:any) => puesto.puesto_id !== currentPuesto.puesto_id);
                setCurrentData(updatedData);
            } else {
              console.error('Error al eliminar puesto');
              toast.error('Error al eliminar puesto');
            }
          } catch (error) {
            console.error('Error al eliminar puesto', error);
            toast.error('Error al eliminar puesto');
          }
          setShowDeleteModal(false);
        }
      };
      return (
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Confirmar eliminación</Modal.Title>
        </div>
          <button type="button" className="modal-close-button" onClick={() => setShowDeleteModal(false)}>
            <X size={22} />
          </button>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que quieres eliminar este puesto?</Modal.Body>
        <Modal.Footer>
        <div className="mp-modal-footer">
          <button type="button" className="mp-modal-btn-cancel" onClick={() => setShowDeleteModal(false)}>Cancelar</button>
          <button type="button" className="mp-modal-btn-submit" onClick={handleDeletePuesto}>Eliminar</button>
        </div>
        </Modal.Footer>
      </Modal>
    )};